module.exports = __webpack_public_path__ + "static/FrameCompanies2-790cab644fd046b071df59cf4739094d.png";